class PlayerSizeAdvice extends HTMLElement {
  connectedCallback() {
    this.variantSelects = this.closest('variant-selects');
    if (!this.variantSelects) return;

    this.updateVisibility();
    this.variantSelects.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.variantSelects?.removeEventListener('change', this.handleChange);
  }

  handleChange = () => {
    requestAnimationFrame(() => this.updateVisibility());
  };

  normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  updateVisibility() {
    const versionControl = Array.from(this.variantSelects.querySelectorAll('[data-option-name]')).find(
      (control) => this.normalize(control.dataset.optionName) === 'version',
    );

    if (!versionControl) {
      this.hidden = true;
      return;
    }

    const value =
      versionControl.tagName === 'OPTION'
        ? versionControl.closest('select')?.value
        : Array.from(this.variantSelects.querySelectorAll('[data-option-name]')).find(
            (control) => this.normalize(control.dataset.optionName) === 'version' && control.checked,
          )?.value;

    this.hidden = this.normalize(value) !== 'jugador';
  }
}

if (!customElements.get('player-size-advice')) {
  customElements.define('player-size-advice', PlayerSizeAdvice);
}
